export default {"src":"/_next/static/media/Mission.0d8a04ef.svg","height":671,"width":1378,"blurWidth":0,"blurHeight":0};